import ServiceBase from './ServiceBase';

class LiveService extends ServiceBase {
    openClient(url) {
        url = url || this.store.state.liveSelect.client_url;
        if (
            this.store.state.commonSetting.pc_protocol_header != "baijiacloud://"
        ) {
            url = url.replace(
                "baijiacloud://",
                this.store.state.commonSetting.pc_protocol_header
            );
        }
        const {
            href
        } = this.router.resolve({
            name: "DownloadClient",
            query: {
                url: url
            }
        });
        window.open(href);
        this.store.commit("showSelectLive", {
            show: false
        });
    }
}

export default () => {
    return new LiveService();
}